import React, { 
  useEffect, 
  useState, 
  useCallback 
} from "react";
import { 
  useDispatch, 
  useSelector, 
  useStore 
} from "react-redux";
import CabListingCardHeaderUI from "../../../../../stories/components/cars/ResultsPage/CabListingCardHeader/CabListingCardHeaderUI";
import CabListItemUI from "../../../../../stories/components/cars/ResultsPage/CabListItem/CabListItemUI";
import OtherCabOptionsUI from "../../../../../stories/components/cars/ResultsPage/OtherCabOptions/OtherCabOptionsUI";
import { 
  fetchBluSmartTgpModalData, 
  fetchHourlyRentalDetails, 
  fetchResults 
} from "../../redux/thunks";
import {
  selectedFilterSelector,
  dispatchSelector,
  isFilterAppliedSelector,
  vehicledataSelector,
  errorSelector,
  topTextWebSelector,
  popupSelector,
  caSelector,
  loaderSelector,
  commonSelector,
  hourlyPackageDetailsSelector,
  showCabTypeDetailModalSelector,
  srpCommonDataSelector
} from "../../redux/selector";
import { 
  atModalDetailsSelector, 
  cabsFaqDataSelector, 
  homeHourlyRentalPackageSelector, 
  hrPackageSelector, 
  osModalDetailsSelector, 
  savaariBannerSelector, 
  sourceSelector, 
  tripTypeSelector 
} from '../../../../common/redux/selector';
import * as S from "./Listing.styles";
import ListingCardLoaderUI from "../../../../../stories/components/cars/ResultsPage/Loaders/ListingCardLoaderUI";
import NoCarsFoundUI from "../../../../../stories/components/cars/ResultsPage/NoCarsFound/NoCarsFoundUI";
import useNavigate from "../../../../hooks/useNavigate";
import { 
  fetchCabsFaqData, 
  fetchGotribe, 
  fetchModalInfoAndPackageDetails, 
  fetchPageMakerAPIs 
} from "../../../../common/redux/thunks";
import ListingLoadingUI from "../../../../../stories/components/cars/ResultsPage/ListingLoading/ListingLoadingUI";
import ReviewPopupUI from "../../../../../stories/components/cars/ResultsPage/Review-popup/Review-popupUI";
import { pageView } from "../../../../../shared/config/ga";
import CabInfoBarUI from "../../../../../stories/components/cars/ResultsPage/CabInfoBar/CabInfoBarUI";
import InfiniteLoader from "../../../../../stories/core-components/InfiniteLoader/InfiniteLoader";
import SmartengageBanner from "../../components/SmartEngage/SmartEngage";
import RydeAssuredCardUI from "../../../../../stories/components/cars/ResultsPage/RydeAssuredBanner/RydeAssuredCard/RydeAssuredCardUI";
import { 
  DEFAULT_RENTAL_PACKAGE, 
  rydeAssuredBannerData, 
  SET_FLOW, 
  UPDATE_RECENT_SEARCH, 
  UPDATE_SEO_FLOW 
} from "../../../../config/constants";
import { 
  gcTripCategoryScreen, 
  getLoadedComponent, 
  pushCtaOmniEvents, 
  sendEventOnError 
} from "../../../../../shared/config/omni";
import CabTypeModalDetails from "../../../../../shared/containers/CabTypeModalDetails/CabTypeModalDetails";
import CabHourlyCarouselUI from "../../../../../shared/containers/CabHourlyCarousel/CabHourlyCarouselUI";
import { 
  UPDATE_HR_PACKAGE, 
  UPDATE_HR_PACKAGE_TIME, 
  UPDATE_TRIP_TYPE 
} from "../../redux/action-types";
import { replaceSRPUrlState } from "../../../../config/utils";
import { 
  CABS_LISTING_ROUTE, 
  DYNAMIC_ERROR, 
  LISTING_PAGE, 
  LOCAL_RENTAL, 
  MOB_CABS_LISTING, 
  NO_RESULT, 
  OW, 
  RT, 
  SRP_SUCCESS 
} from "../../../../utils/util-constants";
import { UPDATE_PAYDATA, UPDATE_SELECTED_CAB } from "../../../SeoPage/redux/seo-action-types";
import parseResultsPageUrlToConfig from "../../../../../../utils/cars-utils/parse-results-page-url-to-config";
import { CTA_TYPE } from "../../../../../shared/utils/omni-utils";
import FrequentAskQuestion from "../../../FaqPage/components/FrequentAskQuestion";
import { UPDATE_CAB_FAQ_DATA } from "../../../../../shared/common/redux/action-types";
import { getTravellerInformation } from "../../../Homepage/redux/thunks";
import TripAssistant from "../../../SeoPage/containers/LeadGenButton/TripAssistant";
import SavaariBanner from "../../../../components/SavaariBanner";

interface IListing {}

const Listing: React.FC<IListing> = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const selectedFilter = useSelector(selectedFilterSelector);
  const dispatchSearchId = useSelector(dispatchSelector);
  const isFilterApplied = useSelector(isFilterAppliedSelector);
  const vehicle_data = useSelector(vehicledataSelector);
  const commonData = useSelector(commonSelector);
  const source = useSelector(sourceSelector);
  const error = useSelector(errorSelector);
  const txt = useSelector(topTextWebSelector);
  const popup = useSelector(popupSelector);
  const caData = useSelector(caSelector);
  const isLoader = useSelector(loaderSelector);
  const hourlyPackageDetails = useSelector(hourlyPackageDetailsSelector)
  const hrDetails = useSelector(homeHourlyRentalPackageSelector)
  const osModalDetails = useSelector(osModalDetailsSelector)
  const atModalDetails = useSelector(atModalDetailsSelector)
  const showCabTypeDetailModal = useSelector(showCabTypeDetailModalSelector)
  const tripType = useSelector(tripTypeSelector)
  const hrSelectedPackageId = useSelector(hrPackageSelector)
  const [showMore, toggleMore] = useState({});
  const [isUpdated, setIsUpdated] = useState(false);
  const [navigateTo] = useNavigate();
  const [showStartup, setStartTime] = useState(false);
  const srpCommonData = useSelector(srpCommonDataSelector);
  const cabFaqData = useSelector(cabsFaqDataSelector)
  const savaariBannerInfo = useSelector(savaariBannerSelector);
  const {ryde_icon_url=''} = srpCommonData || {}

  useEffect(() => {
    if (!Object.keys(source)?.length) {
      fetchSourceFromUrl()
    } 
    dispatch(getTravellerInformation())
    dispatch(fetchResults({})).then(() => {
      getLoadedComponent('Listing')
    });
    dispatch(fetchGotribe({slot: 'cab_srp_carousel_1', page: 'srp'}));
    dispatch(fetchPageMakerAPIs({ isTemplates: 'cabs_dweb_srp' }));
    dispatch(fetchBluSmartTgpModalData())
    if (!cabFaqData?.length) {
      fetchFaqData()
    }
    
  }, []);

  useEffect(() => {
    if (Object.keys(commonData)?.length) {
      dispatch(pageView(gcTripCategoryScreen));
    }
  }, [commonData])

  useEffect(() => {
    setStartTime(true);
  }, [popup]);

  useEffect(() => {
    if (!hrDetails?.packages) {
      dispatch(fetchModalInfoAndPackageDetails())
    } else {
      if (hrDetails?.packages?.length) {
        const packages = hrDetails?.packages
        const selectedPackage = packages.find(item => item?.name === hrSelectedPackageId)
        if (selectedPackage) {
          dispatch({
            type: UPDATE_HR_PACKAGE_TIME,
            packageTime: selectedPackage?.time
          })
        }
      }
    }
  }, [hrDetails, hrSelectedPackageId])

  useEffect(() => {
    if (commonData?.trip_type === LOCAL_RENTAL) {
      dispatch(fetchHourlyRentalDetails())
    }
  }, [commonData])

  useEffect(() => {
    if (error && error?.no_result_title) {
      pushCtaOmniEvents(`${MOB_CABS_LISTING}_${DYNAMIC_ERROR}_${error?.no_result_message}`, CTA_TYPE.HYPER_LINK, LISTING_PAGE, CABS_LISTING_ROUTE)
      sendEventOnError([{field : error?.no_result_title, message : error?.no_result_message }])
    }
  }, [error])

  useEffect(() => {
    if (isUpdated) {
      if(window?.location?.href?.includes('/review') || window?.location?.href?.includes('/results')) {
        replaceSRPUrlState(store);
      }
      setIsUpdated(false);
    }
    if(vehicle_data?.length){
      pushCtaOmniEvents(SRP_SUCCESS, CTA_TYPE.IMAGES, LISTING_PAGE, CABS_LISTING_ROUTE)
    }
  }, [vehicle_data]);

  const fetchFaqData = async () => {
    const faqData = await fetchCabsFaqData()
    if (faqData) {
      dispatch({
        type: UPDATE_CAB_FAQ_DATA,
        faqData: faqData
      });
    }
  }

  const fetchSourceFromUrl = async () => {
    const parseData = await parseResultsPageUrlToConfig(window.location.href);
    dispatch({
      type: UPDATE_RECENT_SEARCH,
      data: parseData,
    });
    dispatch({
      type: SET_FLOW,
      flow: parseData?.flow,
    })
    dispatch({
      type: UPDATE_SEO_FLOW,
      isSeo: parseData?.isSeo,
    })
  }

  const clearFilter = useCallback(() => {
    dispatch({
      type: "CLEAR_FILTER",
      filters: {},
    });
    dispatch(fetchResults({}));
  }, [dispatch]);

  const fetchCabsOnPackageUpdate = () => {
    dispatch(fetchResults({}));
    setIsUpdated(true)
  }

  const naviagteToReview = useCallback(
    (selectedCab) => {
      dispatch({
        type: UPDATE_PAYDATA,
        paydata: {}
      });
      dispatch({
        type: UPDATE_SELECTED_CAB,
        selectedCab: { ...selectedCab, dispatchSearchId },
      });
      navigateTo("confirm");
    },
    [dispatchSearchId]
  );

  const toggleFn = useCallback(
    (index) => {
      const updateMore = { ...showMore, [index]: !showMore[index] };
      toggleMore(updateMore);
    },
    [showMore]
  );

  const getModalDetails = useCallback(
    () => {
      let modalDetails = {}

      switch(tripType?.rf) {
        case "at" :
          modalDetails = atModalDetails?.airportModalData
          break
  
        case "ow" :
        case "rt" :
          modalDetails = osModalDetails?.osModalData
  
          break
  
        case "hr" : 
          modalDetails = hrDetails?.rentalModalDetails
          break
      }
  
      return modalDetails
    },[tripType, atModalDetails, osModalDetails, hrDetails]
  )

  const showRentalSRPData = async (pkg: string) => {  // this function will be called when no cabs found for OS/AT search and we want to show rental data
    dispatch({
      type: UPDATE_HR_PACKAGE,
      package_id: pkg
    });
    dispatch({
      type: UPDATE_TRIP_TYPE,
      tripType: {
        name: 'LOCAL_RENTAL',
        rf: 'hr'
      }
    });
    setStartTime(false)
    dispatch(fetchResults({}));
    setIsUpdated(true)
  }
 
  if(isLoader){
    return (
      <>
        <ListingCardLoaderUI />
        <ListingCardLoaderUI />
        <ListingCardLoaderUI />
      </>
    )
  }
  if (!vehicle_data || !vehicle_data.length) {
    if (Object.keys(selectedFilter)?.length) {
      pushCtaOmniEvents(NO_RESULT, CTA_TYPE.IMAGES, LISTING_PAGE, CABS_LISTING_ROUTE)
      return <NoCarsFoundUI title={error?.no_result_title} subtitle={error?.no_result_message} clearFilter={clearFilter} />
    }
    if (Object.keys(error)?.length) {
      pushCtaOmniEvents(NO_RESULT, CTA_TYPE.IMAGES, LISTING_PAGE, CABS_LISTING_ROUTE)
      return (
        <>
          <NoCarsFoundUI title={error?.no_result_title} subtitle={error?.no_result_message} no_result_image={error?.no_result_image} />
          {!!(showStartup && popup?.t && popup?.msg && error?.redirect_local_rental && tripType?.rf !== "hr") ? <ReviewPopupUI {...popup} updateInfo={() => showRentalSRPData(error?.cta_action || DEFAULT_RENTAL_PACKAGE)} /> : null}
        </>
      )
    }
    return (
      <>
        <ListingCardLoaderUI />
        <ListingCardLoaderUI />
        <ListingCardLoaderUI />
      </>
    );
  }else{
    var showRydeBanner = vehicle_data.some(item=>{
      let showbanner = item.c_d.some(element=>element.is_ryde === true);
      return showbanner === true
    })
  }
  const { heading, subHeading, iconName, sliderList } = rydeAssuredBannerData;
  return (
    <>
      {
        showRydeBanner && false ? (
          <>
            <RydeAssuredCardUI heading={heading} subHeading={subHeading} iconName={iconName} sliderList={sliderList} margin="0 0 1.7rem 0" /> 
          </>
        ) : null
      }
      {!!(showStartup && popup?.t && popup?.msg) ? <ReviewPopupUI {...popup} updateInfo={() => setStartTime(false)} /> : null}
      {isFilterApplied ? <ListingLoadingUI /> : null}
      {tripType?.rf === "hr" ? (
        <>
          {hourlyPackageDetails?.rentalPackages?.length ? (
            <S.HrPackageCard>
              <CabHourlyCarouselUI data={hourlyPackageDetails?.rentalPackages} itemCount={6} onPackageChange={fetchCabsOnPackageUpdate} invokedFor={gcTripCategoryScreen}/>
            </S.HrPackageCard>
          ) : null}
        </>
      ) : (
        <CabInfoBarUI text={txt} />   
      )}
      { (tripType?.rf === OW || tripType?.rf === RT) && <SavaariBanner data={savaariBannerInfo}/>}
      <InfiniteLoader
        showLoader={false}
        actionHandler={() => {}}
      >
        {vehicle_data?.map(({ t_c, c_d = [] }, key) => {
          
          return (
            <>
              {key === 1 ? <SmartengageBanner /> : null}
              <S.ListingCard>
                <CabListingCardHeaderUI {...t_c} key={`clKey${key}`} />
                {c_d.map((item, index) => {
                  if (index >= 1 && !showMore[key]) return null;
                  return (
                    <CabListItemUI
                      {...item}
                      itemKey={item?.key}
                      key={`clItem${index}`}
                      caData={caData}
                      t_c={t_c}
                      c_d={c_d}
                      position={key}
                      commonData={commonData}
                      supplierId={t_c?.supplier_id}
                      packageId={hrSelectedPackageId}
                      naviagteToReview={naviagteToReview}
                      ryde_icon_url={ryde_icon_url}
                      addonString={item?.travel_addon_string}
                    />
                  );
                }) || null}
                <OtherCabOptionsUI
                  {...t_c}
                  showMore={!!showMore[key]}
                  toggleFn={toggleFn}
                  index={key}
                  cdLen={c_d?.length}
                />
              </S.ListingCard>
            </>
          );
        }) || []}
        {commonData?.show_faqs && <FrequentAskQuestion cabFaqData={cabFaqData}/>}
      </InfiniteLoader>
      {showCabTypeDetailModal ? (
        <CabTypeModalDetails item={getModalDetails()}/>
      ) : null}
      <TripAssistant pageName="Listing"/>
    </>
  );
};

export default React.memo(Listing);
